function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMenuClose = function SvgIconMenuClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 10 9"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.927-1.736h.689v12.18h-.689z",
    style: {
      fill: "#251e1c"
    },
    transform: "scale(-1 1)rotate(-47.688 -.238 14.558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.361 4H1.818v.709h-12.179z",
    style: {
      fill: "#251e1c"
    },
    transform: "scale(-1 1)rotate(-42.221 -4.51 4.972)"
  }));
};
export { SvgIconMenuClose as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEwIDkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogICAgIHhtbDpzcGFjZT0icHJlc2VydmUiCiAgICAgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoyOyI+CiAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLDAsMCwxLC0yODYuNDQ4LC00MS45ODc4KSI+CiAgICAgICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoLTAuNjczMTY0LC0wLjczOTQ5MywtMC43Mzk0OTMsMC42NzMxNjQsMjk3LjI5MSw0Ni41Njk3KSI+CiAgICAgICAgICAgIDxyZWN0IHg9IjMuOTI3IiB5PSItMS43MzYiIHdpZHRoPSIwLjY4OSIgaGVpZ2h0PSIxMi4xOCIgc3R5bGU9ImZpbGw6cmdiKDM3LDMwLDI4KTsiLz4KICAgICAgICA8L2c+CiAgICAgICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoLTAuNzQwNTUzLC0wLjY3MTk5OCwtMC42NzE5OTgsMC43NDA1NTMsMjkwLjk1OSw0MC4yNDcxKSI+CiAgICAgICAgICAgIDxyZWN0IHg9Ii0xMC4zNjEiIHk9IjQiIHdpZHRoPSIxMi4xNzkiIGhlaWdodD0iMC43MDkiIHN0eWxlPSJmaWxsOnJnYigzNywzMCwyOCk7Ii8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";